import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getSearch = get('reservation.components.search');

export const getByContext = createSelector(getSearch, get('byContext'));

export const getSearchQueryForContext = createSelector(
  (_, context) => context,
  getByContext,
  get
);
